/// <reference path="../../_ext/Bases/DialogBase.ts" />
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class SequenceDialog extends _Ext.DialogBase<SequenceRow, any> {
        protected getFormKey() { return SequenceForm.formKey; }
        protected getIdProperty() { return SequenceRow.idProperty; }
        protected getLocalTextPrefix() { return SequenceRow.localTextPrefix; }
        protected getNameProperty() { return SequenceRow.nameProperty; }
        protected getService() { return SequenceService.baseUrl; }
        protected getDeletePermission() { return SequenceRow.deletePermission; }
        protected getInsertPermission() { return SequenceRow.insertPermission; }
        protected getUpdatePermission() { return SequenceRow.updatePermission; }

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        protected form = new SequenceForm(this.idPrefix);

    }
}